import React from "react";
import "./Header.css";
const Header = () => {
  return (
    <div className="header">
      <div className="header-text">FREE PNPPLS KEYCHAIN WITH EVERY ORDER</div>
    </div>
  );
};

export default Header;
